export default __webpack_public_path__ + "static/mobile-small-1x-897074b9db8d97724dc601c9f797651a.jpeg";